import React from 'react';
import { XIcon } from 'lucide-react';
import { failures } from '../data/offer';
export function Problem() {
  return <section className="w-full bg-ink" data-id="element-94" data-mp="2pefta07weyil">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-14 px-5 py-20 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:py-28" data-id="element-95" data-mp="2pdedjifxtnuj">
        <div data-id="element-96" data-mp="2gekellf4wldt">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.22em] text-alert" data-id="element-97" data-mp="2ge13anjzov8r">
            The problem
          </p>
          <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-98" data-mp="21olfngfr95xa">
            The random workout trap
          </h2>
          <div className="mt-7 space-y-5 font-sans text-lg leading-relaxed text-muted" data-id="element-99" data-mp="1sqjb4qwtbv59">
            <p data-id="element-100" data-mp="1wruy0ooay29r">
              Most coaches treat HYROX preparation like a hybrid of CrossFit and
              running. They throw heavy sleds at their athletes on Monday and
              hope a long run on Sunday fixes the cardio.
            </p>
            <p className="font-semibold text-white" data-id="element-101" data-mp="1nrznmm2kmbas">
              This is why most athletes underperform.
            </p>
          </div>
        </div>

        <div data-id="element-102" data-mp="oa2cf55lpmiu">
          <p className="font-sans text-sm font-semibold uppercase tracking-[0.16em] text-white/70" data-id="element-103" data-mp="oac2esqnbtoj">
            They arrive at the race with:
          </p>
          <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-104" data-mp="xb0kpzn2og78">
            {failures.map(failure => <li key={failure} className="flex items-start gap-4 py-5" data-id="element-105" data-mp="9lg07cb9tavu">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center bg-alert/15" data-id="element-106" data-mp="5kcjknlefatk">
                  <XIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-107" data-mp="jbr3qxr1li27" />
                </span>
                <p className="font-sans text-base leading-relaxed text-white/85" data-id="element-108" data-mp="el0z5mqfxj8k">
                  {failure}
                </p>
              </li>)}
          </ul>
          <p className="mt-8 font-display text-2xl font-bold uppercase leading-tight tracking-tightest text-white sm:text-3xl" data-id="element-109" data-mp="3mz9gtzrfcply">
            Your reputation is built on their results. If they fail, you fail.
          </p>
        </div>
      </div>
    </section>;
}